// extracted by mini-css-extract-plugin
export default {"EmptySidePanel":"EmptySidePanel-module-ce265166bdb4bce20d64"};